import { FC } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';

import AddIcon from '@mui/icons-material/Add';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import { GridColDef } from '@mui/x-data-grid';
import Can from 'src/components/Can';
import LinkButton from 'src/components/LinkButton';
import Table from 'src/components/Table';
import TableActions from 'src/components/Table/Actions';
import { columnCurrency } from 'src/components/Table/types';
import useApiQueryPagination from 'src/hooks/useApiQueryPagination';
import { IEditParams } from 'src/interfaces/IEditParams';
import { IUser } from 'src/interfaces/models';
import { ATTENDANCE_PERMISSIONS } from 'src/modules/attendance/constants/permissions';
import attendanceApi from 'src/modules/attendance/services/api';

const List: FC = () => {
  const { url } = useRouteMatch();
  const params = useParams<IEditParams>();
  const {
    handlePageChange,
    handlePageSizeChange,
    isLoading,
    data: response,
    refetch,
  } = useApiQueryPagination<IUser>((queryConfig) =>
    attendanceApi.admin.goals.users.useGoalUsersQuery(params.id, queryConfig),
  );

  const columns: GridColDef<IUser>[] = [
    { field: 'id', headerName: 'ID' },
    {
      field: 'amount',
      headerName: 'Meta',
      ...columnCurrency,
    },
    { field: 'name', headerName: 'Nome', flex: 1 },
    {
      field: 'actions',
      headerName: '',
      align: 'right',
      renderCell({ row }) {
        return (
          <TableActions
            resourceName="Usuário"
            resourceId={row.id}
            resourceStatus={row.status}
            editLink={`${url}/${row.id}`}
            editPermissions={[ATTENDANCE_PERMISSIONS.GOALS.UPDATE]}
            destroyApiEndpoint={(resourceId, config) =>
              attendanceApi.admin.goals.users.destroyGoalUser(
                params.id,
                resourceId,
                config,
              )
            }
            destroyPermissions={[ATTENDANCE_PERMISSIONS.GOALS.UPDATE]}
            descriptionPrefix={`O Usuário ${row.name}`}
            onFinish={refetch}
            onlyDelete
          />
        );
      },
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container justifyContent="end" alignItems="center">
          <Can
            behavior="disable"
            permissions={[ATTENDANCE_PERMISSIONS.FUNNELS.STORE]}
          >
            <LinkButton
              to={`${url}/novo`}
              startIcon={<AddIcon />}
              color="primary"
              variant="contained"
              size="small"
            >
              Nova
            </LinkButton>
          </Can>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Table
              autoHeight
              rows={response?.data.data || []}
              pageSize={response?.data.meta.per_page}
              rowCount={response?.data.meta.total}
              columns={columns}
              loading={isLoading}
              pagination
              paginationMode="server"
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default List;
